import { useState } from 'react';
import './LevelSelect.css'

const levelDescriptions = {
    animals: 'Learn the names of birds, fish, bears, turtles, and more.',
    fruits: 'Match common fruits like apples, bananas, berries, and strawberries.',
    bodyparts: 'Practice words for the head, hands, feet, nose, and ears.',
    nature: 'Explore words for trees, rocks, wind, rain, and stars.',
    opposites: 'Discover pairs like day & night, hot & cold, good & bad.'
};

function LevelSelect({ setLevel }) {
    const [flippedCard, setFlippedCard] = useState(null);

    const handleCardClick = (level) => {
        setFlippedCard(level);
    };

    const handleButtonClick = (e, level) => {
        e.stopPropagation();
        setLevel(level);
        setFlippedCard(null);
    }

    return (
        <div className="level-select">
            <div className="level-header">
                <h2>Select a Level</h2>
                <hr />
            </div>
            <div className="level-cards">
                {['animals', 'fruits', 'bodyparts', 'nature', 'opposites'].map((level, index) => (
                    <div key={index} className="level-card-wrapper">
                        <div
                            className={`level-card ${flippedCard === level ? 'flipped' : ''}`}
                            onClick={() => handleCardClick(level)}
                        >
                            <img src={`/img/${level}-card.jpg`} alt={level} className="front" />
                            <div className="back">
                                <img src="/img/blank-card.jpg" alt="blank" />
                                <div className="back-content">
                                    <span
                                        className="close-btn"
                                        onClick={(e) => { e.stopPropagation(); setFlippedCard(null); }}
                                    >&times;</span>
                                    <h3>{level === 'bodyparts' ? 'Body Parts' : level === 'nature' ? 'Nature & Weather' : level.charAt(0).toUpperCase() + level.slice(1)}</h3>
                                    <p>{levelDescriptions[level]}</p>
                                    <button onClick={(e) => handleButtonClick(e, level)}>
                                        Start Game
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default LevelSelect;
